import ContractCardLoader from './contract-card-loader';

export default ContractCardLoader;
